<template>
    <Dialog>
        <DialogTrigger>
            <slot></slot>
        </DialogTrigger>
        <DialogContent>
            <DialogHeader>
                <DialogTitle>
                    {{ $t("affiliate_partners.detail_modal.title") }}
                </DialogTitle>
                <DialogDescription>
                </DialogDescription>
            </DialogHeader>

            <div>
                <div class="grid grid-cols-12 gap-3">
                    <div class="col-span-4">{{ $t("affiliate_partners.link") }}</div>
                    <div class="col-span-8">{{ affiliateLink.link }}</div>
                </div>

                <div class="grid grid-cols-12 gap-3 mt-2">
                    <div class="col-span-4">{{ $t("affiliate_partners.percentage") }}</div>
                    <div class="col-span-8">{{ affiliateLink.percentage }}%</div>
                </div>

                <div class="grid grid-cols-12 gap-3 mt-2">
                    <div class="col-span-4">{{ $t("affiliate_partners.clicks") }}</div>
                    <div class="col-span-8">{{ affiliateLink.clicks }} ({{ affiliateLink.last_click }})</div>
                </div>

                <div class="grid grid-cols-12 gap-3 mt-2">
                    <div class="col-span-4">{{ $t("affiliate_partners.signups") }}</div>
                    <div class="col-span-8">{{ affiliateLink.signups }} ({{ affiliateLink.last_signup }})</div>
                </div>

                <div class="grid grid-cols-12 gap-3 mt-2">
                    <div class="col-span-4">{{ $t("affiliate_partners.purchases") }}</div>
                    <div class="col-span-8">{{ affiliateLink.purchases }} ({{ affiliateLink.last_purchase }})</div>
                </div>

                <div class="grid grid-cols-12 gap-3 mt-2">
                    <div class="col-span-4">{{ $t("affiliate_partners.total_earnings") }}</div>
                    <div class="col-span-8">{{ affiliateLink.total_earnings }}</div>
                </div>

                <div class="grid grid-cols-12 gap-3 mt-2">
                    <div class="col-span-4">{{ $t("affiliate_partners.total_payouts") }}</div>
                    <div class="col-span-8">{{ affiliateLink.total_payouts }} ({{ affiliateLink.last_payout }})</div>
                </div>
            </div>

            <DialogClose>
                <div class="flex w-full justify-end">
                    <Button type="button" variant="outline">
                        {{ $t("close") }}
                    </Button>
                </div>
            </DialogClose>
        </DialogContent>
    </Dialog>
</template>

<script lang="ts" setup>
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogClose,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { usePage } from "@inertiajs/vue3";

defineProps({
    affiliateLink: {
        required: true,
        type: Object,
    },
});

const page = usePage();
</script>
